export default {
    crm: {
        title: "Notizen zum Ereignis",
        menu: {
            cancel  : "Bearbeitung ohne Speichern beenden",
            save    : "Eintrag speichern und beenden",
            edit    : "Notiz bearbeiten",
            delete  : "Notiz löschen",
            undelete: "Notiz wieder herstellen",
            document: "Dokument zur Notiz anzeigen"
        },
        confirm: {
            delete  : "Soll der Eintrag wirklich gelöscht werden?",
            undelete: "Soll der Eintrag wieder hergestellt werden?",
        },
        entry: {
            commit: "Termin bestätigen",
            goto  : "Ereignis anzeigen"
        }
    },

    button: {
        day  : "Tagesübersicht",
        week : "Wochenübersicht",
        month: "Monatsübersicht",
        all  : "Übersicht über alle Termine",
    },
}